import React, { useEffect, useState, useContext } from "react";
import MenuDoctor from "./navDoctor/MenuDoctor";
import PageHeader from "../pageheader/PageHeader";
import { TrashIcon } from "@heroicons/react/24/outline";
import Button from "../material/button/Button";
import * as medicalApi from "../../service/medicalApi";
import ModalUploadFileV2 from "../material/modal/ModalUploadFileV2";
import ModalAddData from "../material/modal/ModalAddData";
import moment from "moment";
import "moment/locale/th";
import { HashLoader } from "react-spinners";
import Pagination from "../pagination/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import styles from "./GuidelineTextEditor.module.css";

import DialogTailwindConfirm from "../DialogTailwindConfirm";
import TableSearchV1 from "../tableV1/tableSearchV1";
import { FaTrashAlt, FaEdit, FaEye } from "react-icons/fa";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

const Guideline = () => {
  const { setIsMessage } = useContext(CurrentUserContext);

  //const [toggle, setToggle] = useState('document') // document, guide
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [total, setTotal] = useState(null);
  const [guideList, setGuideList] = useState([]);
  const [sortBy, setSortBy] = useState({ id: "", desc: false });
  const [date, setDate] = useState("");

  const [openModalAddData, setOpenModalAddData] = useState(false);
  const [guidelineTitle, setGuidelineTitle] = useState("");
  const [guidelineDetail, setGuidelineDetail] = useState("");
  const [showDetail, setShowDetail] = useState(false);
  const [filters, setFilters] = useState({
    title: "",
    "created_date.date": "",
  });

  const [selectedData, setSelectedData] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
    // if (location.state?.type) {
    //   setToggle(location.state?.type)
    // }
  }, []);

  useEffect(() => {
    getGuideline();
  }, [page, filters, sortBy]);

  const getGuideline = async () => {
    setLoading(true);
    let res = await medicalApi.getGuideline(
      page,
      10,
      filters,
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setGuideList(res["data"]["guideline_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const addGuideline = async (title, detail) => {
    setLoading(true);
    let res = await medicalApi.addGuideline(title, detail);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setOpenModalAddData(false);
        getGuideline();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  // ฟังก์ชันเปิด dialog พร้อมบันทึกข้อมูล row ที่ต้องการ
  const openDialog = (rowData) => {
    setSelectedData(rowData);
    setIsDialogOpen(true);
  };

  //เปิด Dialog
  const handleConfirmRemove = async (confirmed, data) => {
    setIsDialogOpen(false);
    if (confirmed && data) {
      if (data?.guideline_id) {
        let res = await medicalApi.removeGuideline(data?.guideline_id);

        if (res) {
          if (res["data"]["code"] === 200) {
            getGuideline();
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    }
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "หัวข้อ",
      accessor: "title",
      Cell: ({ row }) => {
        return (
          <div
            className="cursor-pointer text-[#000000] text-left"
            onClick={() => {
              navigate("/doctor/guideline/add", {
                state: {
                  type: "view",
                  title: row.original.title,
                  detail: row.original.detail,
                },
              });
            }}
          >
            {row.original.title || "-"}
          </div>
        );
      },
      Filter: "text",
      wrap: true,
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "guideline_id",
      Cell: ({ row }) => {
        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px]"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() => {
                navigate("/doctor/guideline/add", {
                  state: {
                    type: "view",
                    title: row.original.title,
                    detail: row.original.detail,
                  },
                });
              }}
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
            <button
              className="text-red bg-red-100 border font-medium rounded-[5px] text-sm p-2"
              onClick={() =>
                openDialog({
                  message: `คุณต้องการลบใช่หรือไม่`,
                  row: row.original,
                })
              }
            >
              <FaTrashAlt style={{ width: "18px" }} color="#d32736" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div class="flex w-full bg-[#ffffff] pb-[30px]">
      <div className={styles.blockContent}>
        <div
          className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
        >
          แนวทางการตรวจแลป
          <span className={styles.fontDate}> (ข้อมูลวันที่ {date}) </span>
        </div>

        <div className="my-4">
          <div className={styles.fontSub}>
            1.
            ท่านสามารถถ่ายทอดประสบการณ์การรักษาหรือแนวทางการตรวจแก่บุคลากรณ์ทางแพทย์ท่านอื่นๆผ่านทางช่องทางนี้ได้
          </div>
          <div className={styles.fontSub}>
            2.
            คลิกหัวข้อเพื่ออ่านการถ่ายทอดประสบการณ์จากบุคลากรทางการแพทย์ได้ที่นี่
          </div>
        </div>

        <TableSearchV1
          columns={columns}
          data={guideList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={total}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          addData={{
            name: "เพิ่มข้อมูล",
            url: "/doctor/guideline/add",
          }}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />

        {openModalAddData ? (
          <>
            <ModalAddData
              onClose={() => {
                setOpenModalAddData(false);
              }}
              titlename="เพิ่มข้อมูลแนวทางการตรวจ"
              showDetail={showDetail}
              defaultTitle={guidelineTitle}
              defaultDetail={guidelineDetail}
              onSubmit={(e) => {
                if (window.confirm("ยืนยันการบันทึก")) {
                  addGuideline(e.title, e.detail);
                }
              }}
            />
          </>
        ) : null}
      </div>
      {/* เปิด DialogTailwindConfirm พร้อมส่งข้อมูล row ที่เลือก */}
      {isDialogOpen && selectedData && (
        <DialogTailwindConfirm
          onConfirm={handleConfirmRemove}
          onCancel={handleConfirmRemove}
          data={selectedData}
        />
      )}
    </div>
  );
};

export default Guideline;
